export const CARS_LIST_DEFAULT_SORTING_TYPE = 'catalogNumber-ASCENDING'
